import styled, { css } from 'styled-components';
import { TinyParagraph } from 'ggApp/shared/common/Typography';
import Arrow from 'ggApp/shared/icons/Arrow';

export const Plan = styled.div`
    flex: 1 0 40%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 8px;
    padding: 0 16px;
    border-right: 2px solid ${({ theme }) => theme.colors['Level 1']};
    border-left: 2px solid ${({ theme }) => theme.colors['Level 1']};
`;

export const Length = styled(TinyParagraph)`
    flex: 1;
    margin: 0 8px;
    text-align: center;
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const Btn = styled.button`
    width: 8px;
    height: 12px;

    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

    path {
        fill: ${({ disabled, theme }) =>
            disabled ? theme.colors['Level 1'] : theme.colors['Level 3']};
    }

    ${({ prev }) =>
        prev &&
        css`
            svg {
                transform: rotate(180deg);
            }
        `};
`;
